import styled from 'styled-components';
import RspImageBg from '../../base/images/rspImageBg';
import media from '../../base/media';

export const Wrapper = styled.div`
	display: flex;
	flex: 100% 0 0;

	.image-gallery {
		min-height: 30rem;
	}

	${media.tablet`
		.image-gallery {
			min-height: 100rem;
		}
		.image-gallery-slide-wrapper.right {
			width: calc(70% - 1rem);
		}
		.image-gallery-thumbnails-wrapper.right {
			width: 30%;

			.image-gallery-thumbnails-container {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-between;

				.image-gallery-thumbnail {
					width: 50%;
				}
			}
		}
	`};
`;

export const MainImage = styled(RspImageBg)`
	flex: 1 0 0;
	padding-top: 100%;
	background-size: cover;
	background-position: 50% 50%;

	${media.tablet`
		padding-top: 35%;
		flex: 65% 0 0;
	`}
`;

export const ExtraImageWrapper = styled.div`
	display: flex;
	flex: 35% 0 0;
	flex-wrap: wrap;

	${media.mobileOnly`
		display: none;
	`}
`;

export const ExtraImage = styled(RspImageBg)`
	flex: 50% 0 0;
	padding-top: 20%;
	background-size: cover;
	background-position: 50% 50%;
`;
